<template>
  <div class="contain page5-con" id="Mobile5">
    <div class="con">
      <div class="con-head title-box">
        <div class="title-chinese">
          <div>
            <p class="line"></p>
            <p class="line"></p>
          </div>
          <h3>案例展示</h3>
          <div>
            <p class="line"></p>
            <p class="line"></p>
          </div>
        </div>
        <div class="title-english">
          <p class="about" style="color: #666">CASE PRESENTATION</p>
        </div>
      </div>
      <swiper
        loop
        ref="mySwiper"
        class="swiper"
        :options="swiperOption"
        style="height: 100%"
      >
        <swiper-slide v-for="(it, i) in swiperIndex" :key="i">
          <div class="content">
            <ul>
              <li
                v-for="(item, index) in firstCaseData"
                :key="index"
                :style="{
                  backgroundImage: 'url(' + item.img + ')',
                }"
                @click="gotoDetail(item)"
              >
                <div class="img-box hidden-md-and-up">
                  <img :src="item.img" :alt="item.title" />
                </div>

                <div class="mask">
                  <div class="maskBox">
                    <h3>案例介绍：</h3>
                    <div v-html="item.title" class="vHtml-info"></div>
                    <span class="hidden-sm-and-down">
                      <i class="el-icon-right"></i>
                    </span>
                  </div>
                </div>
              </li>
            </ul>

            <ul class="lastCase hidden-sm-and-down">
              <li
                v-for="(item, index) in lastCaseData"
                :key="index"
                :style="{
                  backgroundImage: 'url(' + item.img + ')',
                }"
                @click="gotoDetail(item)"
              >
                <div class="mask">
                  <div class="maskBox">
                    <h3>案例介绍：</h3>
                    <div v-html="item.title" class="vHtml-info"></div>
                    <span class="hidden-sm-and-down">
                      <i class="el-icon-right"></i>
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { getArticleList } from "@/api/home/index";
import { removeHtmlStyle } from "@/utils/removestyle";
// import { delHtmlTag } from "@/utils/index.js";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  data() {
    return {
      firstRender: true,
      currentIdx: 0,
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        // slidesPerGroup: 3,
        loop: false,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false, // 当用户滑动图片后继续自动轮播
        },
        loopFillGroupWithBlank: true,
        params: {
          categorys: "新闻资讯",
          show: 1,
        },
      },
      caseData: [],
      originData: [],
      params: {
        categorys: "案例",
        show: 1,
      },
      swiperIndex: 2,
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  computed: {
    firstCaseData: function () {
      return this.caseData.filter((item, index) => index < 4);
    },
    lastCaseData: function () {
      return this.caseData.filter((item, index) => index >= 4);
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    // 轮播图切换
    let _this = this;
    this.swiper.on("slideChange", function () {
      _this.originData.push(_this.caseData[0]);
      _this.caseData.shift();
      _this.caseData.push(_this.originData[0]);
      _this.originData.shift();
      _this.swiperIndex++;
    });
  },
  methods: {
    removeHtmlStyle,
    getData() {
      getArticleList(this.params).then((res) => {
        //过滤首页不显示
        const filterCaseData = (this.caseData = res.data.list.filter(
          (item) => item.highlight == 1
        ));
        this.originData = filterCaseData.filter((item, index) => index >= 8);
        this.caseData = filterCaseData.filter((item, index) => index < 8);
        //this.caseData = filterCaseData.filter((item, index) => true);
      });
    },
    gotoDetail(item) {
      this.$router.push("/article/articleDetail?type=case&id=" + item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.page5-con {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  .con {
    height: 100%;
    overflow: hidden;
    padding-top: 80px;
    box-sizing: border-box;
    .con-head .el-row {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .el-col-6 {
        width: 20%;
      }
      .el-col {
        h3 {
          font-size: 38px;
          color: #da5351;
        }
        .line {
          width: 85px;
          height: 2px;
          background-color: #d8d8d8;
          display: none;
        }
        .line:last-child {
          margin-top: 2px;
        }
      }
      p.about {
        font-size: 18px;
        margin-top: 16px;
        margin-bottom: 26px;
      }
    }
    .con-head {
      height: 15%;
    }

    .content {
      width: 100%;
      height: 85%;
      ul {
        display: flex;
        justify-content: center;
        padding-top: 20px;
        // overflow-x: hidden;
        li {
          position: relative;
          width: 32%;
          height: 0;
          padding-top: 17.28%;
          border-radius: 4px;
          background-repeat: no-repeat;
          background-size: cover;
          margin: 1% 5px 0 5px;
          &:nth-child(2),
          &:nth-child(3) {
            flex-shrink: 0;
            background-size: 100% 100%;
          }
          &:nth-child(1) {
            border-top-left-radius: 0;
            margin-left: 0;
            background-position: right;
          }
          &:nth-child(4) {
            border-top-right-radius: 0;
            margin-right: 0;
            background-position: left;
          }
          div.mask {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            bottom: 0;
            border-radius: 4px;
            left: 0;
            display: none;
            background-color: rgba($color: #000000, $alpha: 0.7);
            padding: 10%;
            box-sizing: border-box;
            text-align: left;
            cursor: pointer;
            .maskBox {
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: start;
              opacity: 0.8;
              h3 {
                line-height: 24px;
                font-size: 24px;
              }
              span {
                display: block;
                width: 46px;
                height: 46px;
                line-height: 46px;
                border-radius: 25px;
                border: 2px solid #ffffff;
                font-weight: lighter;
                text-align: center;

                i {
                  font-size: 36px;
                  vertical-align: middle;
                }
              }
            }
          }
        }
        li:hover {
          div.mask {
            display: block;
          }
        }
      }
      .lastCase {
        padding: 0;
        margin-top: 10px;
        li {
          margin-top: 0;
        }
      }
    }
  }
}

@media screen and (max-width: 960px) {
  #Mobile5 {
    width: 100%;
    .con {
      padding: 0.24rem 0;
      height: 100%;
    }
    .content {
      height: 100%;
      width: 100%;
      ul {
        padding: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        li {
          width: 1.65rem;
          height: 1.76rem;
          margin: 0;
          margin-bottom: 0.12rem;
          display: flex;
          flex-direction: column;
          background-image: none !important;
          border: 1px solid rgba(151, 151, 151, 0.14);
          border-radius: 0.04rem;
          padding: 0;
          &:nth-child(n + 5) {
            display: none;
          }
          .img-box {
            width: 100%;
            img {
              width: 100%;
              height: 0.98rem;
              vertical-align: bottom;
            }
          }

          .mask {
            position: static;
            cursor: none;
            display: block;
            background-color: rgba(216, 216, 216, 0.14);
            padding: 0.12rem;
            border-radius: 0;
            .maskBox {
              h3 {
                font-size: 0.14rem;
                color: #333333;
                line-height: 0.14rem;
              }
              p {
                font-size: 0.12rem;
                line-height: 0.17rem;
                color: #b3b3b3;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
// v-html渲染的样式
.mask {
  overflow: hidden;
  .vHtml-info {
    width: 100%;
    margin: 20px 0;
    flex: 1;
    p {
      display: block;
      width: 100%;
      font-size: 20px;
      line-height: 28px;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
    }
  }
}
@media screen and (max-width: 960px) {
  #Mobile5 {
    .mask {
      overflow: hidden;
      .vHtml-info {
        width: 100%;
        margin: 0;
        margin-top: 0.07rem;
        font-size: 0.12rem;
        color: #b3b3b3;
        p {
          font-size: 0.12rem;
          line-height: 0.17rem;
          color: #b3b3b3;
          display: block;
          width: 100%;
          height: 100%;
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
    }
  }
}
</style>
